<template>
  <div>
    <span
      class="pointer"
      v-for="(route, index) in routeBack"
      v-bind:key="index"
      v-bind:class="{'backBar': (index - (routeBack.length -1) < 0)}"
      v-on:click="goBack(route, index)">
      <span v-if="routeBack.length > 1">/ </span>{{ route.toUpperCase() }}
    </span>
    <hr>
    <div class="alert alert-warning" v-if="!$online">
      <span>
        <center>
            <v-icon size="25">error</v-icon>
            <b>Bitte stellen Sie eine Internetverbindung her!</b>
            <v-icon size="25">error</v-icon>
        </center>
      </span>
    </div>
    <div class="alert alert-warning" v-if="!$online && upload">
      <span>
        <center>
            <v-icon size="25">error</v-icon>
            <b>Internetverbindung benötigt um Daten hochzuladen!</b>
            <v-icon size="25">error</v-icon>
        </center>
      </span>
    </div>
    <div class="alert alert-success" v-if="showSuccess">
      <button type="button" aria-hidden="true" class="close" v-on:click="disableNotification" v-if="uploadZaehler === uploadAnzahl"><v-icon size="30">close</v-icon></button>
      <span><center>
        <v-icon color="green" size="25">check</v-icon>
          <b v-if="uploadZaehler !== uploadAnzahl">Es wurde {{ uploadZaehler }} von {{ uploadAnzahl }} mit der Datenbank synchronisiert!</b>
          <b v-else>Es wurden alle Checklisten ({{ uploadAnzahl }}) mit der Datenbank synchronisiert!</b>
        </center>
      </span>
    </div>
    <div class="alert alert-danger" id="Alarm" v-if="showAlarm">
      <button type="button" aria-hidden="true" class="close" v-on:click="disableNotification"><v-icon size="30">close</v-icon></button>
      <span><center>
          <v-icon size="25">error</v-icon>
        <b>Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut!</b>
        </center>
      </span>
    </div>
    <div class="card">
      <v-progress-linear v-if="loading" color="red" :indeterminate="true"></v-progress-linear>
      <div class="card-header text-xs-inline" id="graphheader">
        <h4 class="card-title">
          {{ title }} {{ subtitle }}
          <v-btn
            flat
            icon
            color="grey"
            id="graphbutton"
            title="Neuen Eintrag erstellen"
            v-on:click="addLog"
          >
            <v-icon size="50">add_circle</v-icon>
          </v-btn>
          <v-btn flat icon color="green" id="graphbutton" title="Zum Upload" :disabled="!(upload && $online)" v-on:click="pushUpload()">
            <v-icon size="50">cloud_upload</v-icon>
          </v-btn>
        </h4>
        <p class="card-category tablecard" id="subtitle"></p>
        <v-form>
          <v-container class="auswahl">
            <v-layout align-center wrap>
              <v-flex shrink pa-2>
                <label for="startdate">Startdatum:&nbsp;</label>
                <input type="date" id="date" v-model="startdate" />
                &nbsp;&nbsp;&nbsp;
                <label for="enddate">Enddatum:&nbsp;</label>
                <input type="date" id="date" v-model="enddate" />
              </v-flex>
              <v-flex pa-2>
                <v-btn color="grey" v-on:click="fetchData(startdate, enddate)">anzeigen</v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </div>
    </div>
    <div class="table-responsive">
      <table class="table table-striped">
        <thead>
          <tr>
            <th>Status</th>
            <th>Anzeigen</th>
            <th>Datum</th>
            <th>Uhrzeit</th>
            <th>Name</th>
            <th>Bemerkung</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="checklist in checklists" v-bind:key="checklist.id">
            <td v-if="checklist.synchronized"><v-icon color="green">cloud_done</v-icon></td>
            <td v-else ><v-icon color="red">cloud_upload</v-icon></td>
            <td><v-icon @click="pushChecklist(checklist.id, checklist.tempID)">search</v-icon></td>
            <td>{{ transformDate(checklist.datum) }}</td>
            <td>{{ transformTime(checklist.uhrzeit) }}</td>
            <td>{{ checklist.name }}</td>
            <td>{{ checklist.bemerkung }}</td>
          </tr>
          <tr v-if="checklists.length === 0 && !loading">
            <td colspan="6" style="text-align: center">Keine Daten gefunden.</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import navigation from '../../../../../store/navigation';

export default {
  data() {
    return {
      startup: 1,
      upload: false,
      showAlarm: false,
      showSuccess: false,
      uploadAnzahl: 0,
      uploadZaehler: 0,
      routeBack: [],
      title: "Reinigungsnachweise - ",
      subtitle: "",
      bereichID: undefined,
      checkDate: false,
      startdate: "",
      enddate: "",
      auth: "Basic " + window.btoa(process.env.VUE_APP_NODE_AUTH),
      checklists: [],
      localChecklists: [],
      loading: false
    };
  },
  methods: {
    goBack(route) {
      if (route !== "reinigungsnachweise") {
        this.$router.push({path: navigation.createNav(route).path});
      }
    },
    disableNotification(){
      this.showAlarm = false;
      this.showSuccess = false;
    },
    pushChecklist(id, tempID) {
      if (id) {
        this.$router.push({ path: this.subtitle.toLowerCase() + "/checklist/" + id, query: { title: this.subtitle, bereichID: Number(this.bereichID)} });
      } else {
        id = -1;
        this.$router.push({ path: this.subtitle.toLowerCase() + "/checklist/" + id, query: { title: this.subtitle, bereichID: Number(this.bereichID), tempID: tempID} });
      }
    },
    addLog() {
      this.$router.push({ path: this.subtitle.toLowerCase() + "/checklist/add/" + this.bereichID, query: { title: this.subtitle} });
    },
    transformDate(date) {
      var today = new Date(date);
      var dd = String(today.getDate()).padStart(2, "0");
      var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      var yyyy = today.getFullYear();

      var newdate = dd + "." + mm + "." + yyyy;
      return newdate;
    },
    transformTime(time) {
      var tranformedTime = time.substring(0, 5);
      return tranformedTime;
    },
    startupFetch() {
      this.loading = true;
      var today = new Date();
      today.setDate(today.getDate() - 7);
      var dd = String(today.getDate()).padStart(2, "0");
      var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      var yyyy = today.getFullYear();

      var startdate = yyyy + "-" + mm + "-" + dd;
      this.startdate = startdate;

      var weekAgo = new Date();
      var dd1 = String(weekAgo.getDate()).padStart(2, "0");
      var mm1 = String(weekAgo.getMonth() + 1).padStart(2, "0"); //January is 0!
      var yyyy1 = weekAgo.getFullYear();
      var enddate = yyyy1 + "-" + mm1 + "-" + dd1;
      this.enddate = enddate;
      this.fetchData(startdate, enddate);
    },
    pushUpload() {
      const checklists = JSON.parse(localStorage.getItem('checklistQS' + this.$route.query.bereichID));
      this.uploadAnzahl = checklists.length;
      for(let i = 0; i < checklists.length; i++) {
        this.$http.post(process.env.VUE_APP_NODE_API_URL+'/heimspiel/qs/checklist/add', checklists[(checklists.length - 1) - i], { headers: {'Authorization': this.auth }})
        .then(function(response) {
          if(response.body.error){
              console.log(response.body.error);
              this.showAlarm = true;
            } else {
              this.showSuccess = true;
              if (i === (checklists.length - 1)) {
                localStorage.removeItem('checklistQS' + this.$route.query.bereichID);
                this.localChecklists = [];
                this.upload = false;
                this.fetchData(this.startdate, this.enddate);
              }
              this.uploadZaehler += 1;
            }
        });
      }
    },
    fetchData(start, end) {
      if (start > end) {
        this.checkDate = true;
      } else {
      console.log("abrufen der Logs aus der DB", this.bereichID);
      this.$http
        .get(
          process.env.VUE_APP_NODE_API_URL +
            "/heimspiel/qs/checklists/" +
            this.bereichID + 
            "/" +
            start +
            "&" +
            end,
          { headers: { Authorization: this.auth } }
        )
        .then(function (response) {
          // wenn nicht der StartupFetch, dann vorher Logs löschen
          if (this.startup === 0) {
            this.checklists = [];
          }
          this.checklists = response.body.data;
          this.checklists.map(checklist => checklist.synchronized = true);
          // statup = 0 damit die Logs geleert werden wenn neue abgerufen werden
          if (this.localChecklists.length > 0) {
            this.localChecklists.map(checklist => {
              checklist.synchronized = false;
              this.checklists.unshift(checklist);
            });
          }
          this.startup = 0;
          this.loading = false;
        });
      }
    },
  },
  created: function () {
    this.routeBack = navigation.createNav('reinigungsnachweise').params;
    if (this.$route.query) {
      this.bereichID = Number(this.$route.params.bereichID);
      if (this.bereichID === 1) {
        this.subtitle = "Servicebereich";
      } else if (this.bereichID === 2) {
        this.subtitle = "Fleischtheke";
      } else if (this.bereichID === 3) {
        this.subtitle = "Wursttheke";
      } if (this.bereichID === 4) {
        this.subtitle = "Käsetheke";
      } 
    }
    this.startupFetch();
  },
  mounted() {
    if (localStorage.getItem('checklistQS' + this.$route.query.bereichID)) {
      try {
        this.localChecklists = JSON.parse(localStorage.getItem('checklistQS' + this.$route.query.bereichID));
        this.localChecklists.map((checklist, index) => {
          checklist.synchronized = false;
          checklist.tempID = index;
          this.checklists.unshift(checklist);
        });
        this.upload = true;
      } catch (e) {
        localStorage.removeItem(localStorage.getItem('checklistQS' + this.$route.query.bereichID));
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#frame {
  margin-left: 0%;
  margin-top: 0%;
  padding-left: 0%;
  padding-top: 0%;
  padding-right: 0%;
}
.unterschriftTD {
  padding: 0%;
}
#date {
  margin-bottom: 10px;
  padding: 5px;
  border: 2px solid rgb(117, 108, 108);
  border-radius: 5px;
}
.auswahl {
  padding: 3px 3px 10px 3px !important;
}
.backBar:hover {
  cursor: pointer;
  text-decoration: underline;
  color: red;
}
.pointer {
  cursor: default;
}

</style>

